import fgfConfig from "./fgf";
import l30Config from "./l30";

const TENANTS = [fgfConfig, l30Config];

/**
 * @deprecated Use API-driven tenant config via TenantBootstrap instead.
 * This static resolver is kept only as a synchronous fallback for the initial
 * cached render before /api/tenant/config responds, and for backwards
 * compatibility during the migration period. It will be removed once all
 * tenants are fully managed in the platform Cosmos DB.
 */
export function resolveTenant() {
  const hostname = window.location.hostname;
  if (hostname.includes("l30") || hostname.includes("latitude30")) return l30Config;
  return fgfConfig;
}

export { fgfConfig, l30Config, TENANTS };
export default resolveTenant;
